import { Block } from 'webiq.boilerplate'

export default class Typewriter extends Block {
	static title = 'title'

	init() {
		if (this.hasModifier('typewriter')) {
			this.textArray = ['webshop', 'website']
			this.textArrayIndex = 0
			this.charIndex = 0

			setTimeout(() => this.setHtmlContent(), 1000)
		}
	}

	setHtmlContent() {
		this.element.innerHTML = ''
		setTimeout(() => this.type(), 500)
	}

	type() {
		if (this.charIndex < this.textArray[this.textArrayIndex].length) {
			this.element.textContent += this.textArray[this.textArrayIndex].charAt(this.charIndex)
			this.charIndex = this.charIndex + 1
			setTimeout(() => this.type(), 200)
		} else {
			setTimeout(() => this.erase(), 2000)
		}
	}

	erase() {
		if (this.charIndex > 0) {
			this.element.textContent = this.textArray[this.textArrayIndex].substring(0, this.charIndex - 1)
			this.charIndex = this.charIndex - 1
			setTimeout(() => this.erase(), 100)
		} else {
			this.textArrayIndex = this.textArrayIndex + 1
			if (this.textArrayIndex >= this.textArray.length) {
				this.textArrayIndex = 0
			}
			setTimeout(() => this.type(), 1200)
		}
	}
}
